// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__31jZz","top":"styles_top__1jumn","left":"styles_left__3IiKx","description":"styles_description__HSDFU"};